module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// (webpack)/~/readable-stream/duplex-browser.js
// module id = 1054
// module chunks = 0